import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { CountryDataService } from '../services/country.service';
import { Utility } from '../shared/utility/utility';

@Injectable()
export class BannerService {
  banners;
  details = new Array();
  isBannerAvailable;
  countryDetails;
  bannerPromiseRequestStack =[];
  cashierBanners={};
  constructor(
    private ajaxService: AjaxService,
    private countryDataService: CountryDataService,
    private utils: Utility
  ) { }
  /*
  Function to get the banners through following processes
    1. BannerResponse (array of banners) of a particular zoneID are stored in an array of objects "this.details". If banner is not available then initiate call for banner
    2. this.bannerPromiseRequestStack is an array of arrays , where request for same zoneIDs are pushed when request for the same zoneID is more than one time.
    3. If "isBannerAvailable" has data i.e corresponding banner for a specific zone ID is avaialble then no more calls are done. This reduces the amount of http calls
    Points to remember:
    a. Each banner call made to backend , indirectly calls getAvailableBonuses , which is a costly call, thus the need for call optimisation
    b. Here reflection of instantaneous change in CMS , in frontend cannot happen
    c. Banners are called during the dollowing events: HomePage (Loggedout state and Loggedin state), Login, Registration, Promotion, Timerbanner) 
  */
  getBanners(bannerReqData) {
    /*Checking for banners in the array of objects, to respond with the banner already stored*/
    let langCode = localStorage.getItem("langCode") ? localStorage.getItem("langCode") : 'en';
    this.isBannerAvailable= this.getAvailablebanners(bannerReqData.zoneId)
    if (this.isBannerAvailable && this.isBannerAvailable.length) {
      this.banners= this.isBannerAvailable;
      return this.banners;
    }
    else {
      if(!langCode){
        return [];
      }
      if (this.utils.getAffliateId('affiliate') ){ 
        bannerReqData["affiliateId"] = this.utils.getAffliateId('affiliate')
      }
      return new Promise((resolve, reject) => {
        /*If banner is available in array for the corresponding zoneId*/
        if (this.bannerPromiseRequestStack[bannerReqData.zoneId] && this.bannerPromiseRequestStack[bannerReqData.zoneId].length > 0) {
          this.bannerPromiseRequestStack[bannerReqData.zoneId].push(resolve);
        } else {
        /*If banner not available in array for the corresponding zoneId*/
          this.bannerPromiseRequestStack[bannerReqData.zoneId] = [];
          this.bannerPromiseRequestStack[bannerReqData.zoneId].push(resolve);
          Promise.resolve(this.ajaxService.getBanners(bannerReqData)).then(res => {
            this.banners = res;
            this.setBanners(bannerReqData.zoneId, this.banners)
            /*Loop through the callbacks and respond to the callbacks of the particular zoneID for which response is recieved. Later empty that particular array*/
            for (let callback in this.bannerPromiseRequestStack[bannerReqData.zoneId]) {
                if (callback)
                  this.bannerPromiseRequestStack[bannerReqData.zoneId][callback](this.banners);
              }
            this.bannerPromiseRequestStack[bannerReqData.zoneId] = [];
          },SystemError => { });
        }
      });
    }
  }

  setBanners(zoneId, banner) {
    this.details.push({
      "zoneId": zoneId,
      "banners": banner
    });
  }
clearBanners(){
    this.details = new Array();
}
  getAvailablebanners(zoneId) {
    let j;
    let count= this.details.length;
    if (this.details && this.details.length > 0) {
      for (let i = 0; i < this.details.length; i++) {
        if (zoneId === this.details[i].zoneId) {
          j =i;
          i = count++;
          return this.details[j].banners;
        }
      }
    }
  }

  getTimeBanners(bannerReqData) {
    if(!localStorage.getItem("langCode")){
      return [];
    }
    return Promise.resolve(this.ajaxService.getBanners(bannerReqData)).then(
      banners => {
        this.banners = banners;
        this.setBanners(bannerReqData.zoneId, this.banners)
        return banners;
      });
  }

  getCountry() {
    if(this.countryDetails) return {"country":this.countryDetails,"broadcast":false};
    return Promise.resolve(this.countryDataService.getCountriesDetails()).then(regData => {
      this.countryDetails = regData;
      return {"country":this.countryDetails,"broadcast":true};
    });
  }

}
